module.exports = __webpack_public_path__ + "img/FLECHE_DROITE.903ce929.svg";